import React, { useState, useEffect, use } from "react";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import {
  MDBIcon,
  MDBBtn,
  MDBContainer,
  MDBJumbotron,
  MDBCardImage,
  MDBCardTitle,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardHeader,
  MDBCardText,
  MDBCardUp,
  MDBCardBody,
  MDBInput,
  MDBCardFooter,
  MDBFormInline,
} from "mdbreact";

import { setUserAccount } from "../features/account/accountSlice";
import { useDispatch, useSelector } from "react-redux";

import nutechanimation from "../nutech.json";

import { useLottie } from "lottie-react";
import { Redirect } from "react-router-dom";
import { Bounce, ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import GoogleButton from "react-google-button";
const LoginFormGoogle = (props) => {
  const userAccount = useSelector((state) => state.account.value);
  const dispatch = useDispatch();
  const [user, setUser] = useState([]);
  const [userName, setUserName] = useState("");
  const [profile, setProfile] = useState([]);
  const toastId = React.useRef(null);

  const notify = (message) => {
    toast(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold blue-text",
    });
  };

  const warning = (message) => {
    toast.error(() => message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold white-text",
    });
  };

  const options = {
    animationData: nutechanimation,
    loop: true,
    h: 1000,
  };
  const { View } = useLottie(options);
  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setUser(codeResponse);
    },
    onError: (error) => console.log("Login Failed:", error),
  });

  useEffect(() => {
    if (user.access_token === undefined) return;
    if (user) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          setProfile(res.data);

          setUserName(res.data.email);
          sessionStorage.setItem("User", res.data.email);
          sessionStorage.setItem("Email", res.data.email);
          sessionStorage.setItem("accountname", res.data.name);
        })
        .catch((err) => {
          warning(
            "The system is currently unavailable. Please try again later."
          );
        });
    }
  }, [user]);

  // log out function to log the user out of google and set the profile array to null
  const logOut = () => {
    googleLogout();
    setProfile(null);
  };

  useEffect(() => {
    if (userName !== "") {
      axios
        .post(props.apiServer + "/bearer?username=" + userName)
        .then((res) => {
          if (res.data.status === "1") {
            sessionStorage.setItem("hash", res.data.hash);
            sessionStorage.setItem("msal.ec", res.data.msalec);
            sessionStorage.setItem("msal.in", res.data.msalin);
            sessionStorage.setItem("msal.uc", res.data.msaluc);
            window.location.replace(props.deployURL + "/");
          } else {
            sessionStorage.removeItem("User");
            sessionStorage.removeItem("Email");
            sessionStorage.removeItem("hash");
            window.location.replace(props.deployURL + "/AccessDenied");
          }
        })
        .catch((error) => {
          // console.log(error);
          warning(
            "The system is currently unavailable. Please try again later."
          );
        });
    }
  }, [userName]);

  // useEffect(() => {
  //   if (userName !== "") {
  //     window.location.replace("/");
  //   }
  // }, [sessionStorage.getItem("msal.uc")]);

  return (
    <React.Fragment>
      {userName === "" ? (
        <React.Fragment>
          <MDBContainer className="text-center" fluid>
            {/* <MDBRow>
              <MDBCol md="12" xs="12" sm="12" lg="3"></MDBCol>
              <MDBCol md="12" xs="12" sm="12" lg="6">
                <img
                  src={props.deployURL + "/nutechoriginal.jpg"}
                  className="img-responsive mb-0 pb-0"
                  width="280"
                />
              </MDBCol>
              <MDBCol md="12" xs="12" sm="12" lg="3"></MDBCol>
            </MDBRow> */}

            <MDBRow>
              <MDBCol md="12" xs="12" sm="12" lg="3"></MDBCol>
              <MDBCol md="12" xs="12" sm="12" lg="6">
                <div className="w-100 pt-0 mt-0 pb-0 mb-0">{View}</div>
              </MDBCol>
              <MDBCol md="12" xs="12" sm="12" lg="3"></MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="12" xs="12" sm="12" lg="3"></MDBCol>
              <MDBCol md="12" xs="12" sm="12" lg="6" className="text-center">
                <span className="h3-responsive font-weight-bold pb-0">
                  <b>NUTECH AUTO CARE CENTER</b>
                </span>
                {/* <hr className="my-2" /> */}
                <p className="font-weight-bold blue-text">
                  ONLINE BOOKING SYSTEM
                </p>
              </MDBCol>
              <MDBCol md="12" xs="12" sm="12" lg="3"></MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="12" xs="12" sm="12" lg="3"></MDBCol>
              <MDBCol md="12" xs="12" sm="12" lg="6" className="flex-center">
                <GoogleButton
                  onClick={login}
                  className="font-weight-bold"
                  type="light"
                />
              </MDBCol>
              <MDBCol md="12" xs="12" sm="12" lg="3"></MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol md="3" xs="3"></MDBCol>
              <MDBCol md="12" xs="6"></MDBCol>
              <MDBCol md="3" xs="3"></MDBCol>
            </MDBRow>
          </MDBContainer>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <h1>{userName}</h1>
          <Redirect
            to={{
              pathname: "/",
              state: { from: props.location },
            }}
          />
          {/* <Navigate to="/" /> */}
        </React.Fragment>
      )}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      ></ToastContainer>
    </React.Fragment>
  );
};
export default LoginFormGoogle;
